import { useState } from 'react'
import { useSelector } from 'react-redux'
import styled from 'styled-components'
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt'
import GroupAddIcon from '@mui/icons-material/GroupAdd'
import InsightsIcon from '@mui/icons-material/Insights'
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts'
import MemberOf from './MemberOf'
import MyMembers from './MyMembers'
import AddMembers from '../inviteMembers/AddMembers'
import Requests from '../Requests'
import Engagement from '../engagement/Engagement'
import { useTranslation } from 'react-i18next'

const memberSections = [
    {
        key: 'manage',
        Icon: ManageAccountsIcon,
    },
    {
        key: 'invite',
        Icon: PersonAddAltIcon,
    },
    {
        key: 'requests',
        Icon: GroupAddIcon,
    },
    {
        key: 'engagement',
        Icon: InsightsIcon,
    },
]

function MembersWrap() {
    const { t } = useTranslation('settings')
    const { user } = useSelector((state) => state.auth)
    const [activeSection, setActiveSection] = useState('manage')

    const renderChurchSection = () => {
        if(activeSection === 'invite') return <AddMembers />
        if(activeSection === 'requests') return <Requests />
        if(activeSection === 'engagement') return <Engagement />
        return <MyMembers />
    }
  
    return (
        <MemberSectionWrap>
            { user && (user.isOrganization || user.isChurch) ?
                (
                    <>
                        <MemberTiles>
                            {memberSections.map(({ key, Icon }) => (
                                <MemberTile
                                    key={key}
                                    active={activeSection === key}
                                    onClick={() => setActiveSection(key)}
                                    type="button"
                                >
                                    <TileIcon active={activeSection === key}>
                                        <Icon />
                                    </TileIcon>
                                    <TileLabel>{t(`membership.tabs.${key}`)}</TileLabel>
                                </MemberTile>
                            ))}
                        </MemberTiles>
                        <MemberSectionBody>
                            {renderChurchSection()}
                        </MemberSectionBody>
                    </>
                )
                :
                (
                    < MemberOf />
                ) 
            }
        </MemberSectionWrap>
    )
}

export default MembersWrap

const MemberSectionWrap = styled.div`
    width: 100%;
    min-height: 100%;
    display: flex;
    flex-direction: column;
`

const MemberTiles = styled.div`
    width: 100%;
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 14px;
    padding: 20px 20px 10px;

    @media (max-width: 900px) {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    @media (max-width: 520px) {
        grid-template-columns: 1fr;
        padding: 12px 10px 8px;
    }
`

const MemberTile = styled.button`
    min-height: 96px;
    border: 1px solid ${props => props.active ? 'var(--themeColor)' : '#e6e8ec'};
    background: ${props => props.active ? 'rgba(0, 180, 204, 0.08)' : '#fff'};
    color: var(--lightThemeFontColor);
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 9px;
    cursor: pointer;
    transition: border-color .18s ease, background .18s ease, transform .18s ease;

    &:hover {
        border-color: var(--themeColor);
        background: rgba(0, 180, 204, 0.06);
        transform: translateY(-1px);
    }
`

const TileIcon = styled.div`
    width: 40px;
    height: 40px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${props => props.active ? '#fff' : 'var(--themeColor)'};
    background: ${props => props.active ? 'var(--themeColor)' : 'rgba(0, 180, 204, 0.1)'};

    svg {
        font-size: 23px;
    }
`

const TileLabel = styled.div`
    font-size: 13px;
    font-weight: 700;
`

const MemberSectionBody = styled.div`
    width: 100%;
    min-height: 0;
`
